export function getHandbookName (item) {
  return item?.name || '-'
}
